'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  boxSizing: _propTypes2.default.string,
  clear: _propTypes2.default.string,
  clearfix: _propTypes2.default.bool,
  display: _propTypes2.default.string,
  float: _propTypes2.default.string,
  zIndex: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

var propAliases = exports.propAliases = {};

var propValidators = exports.propValidators = {};

var _display = {
  className: 'dspl',
  cssName: 'display',
  jsName: 'display',
  safeValue: true,
  isPrefixed: true
};
var _float = {
  className: 'flt',
  cssName: 'float',
  jsName: 'float',
  safeValue: true
};
var _clear = {
  className: 'clr',
  cssName: 'clear',
  jsName: 'clear',
  safeValue: true
};
var _zIndex = {
  className: 'z-idx',
  cssName: 'z-index',
  jsName: 'zIndex',
  safeValue: true,
  defaultUnit: ''
};
var _boxSizing = {
  className: 'box-szg',
  cssName: 'box-sizing',
  jsName: 'boxSizing',
  safeValue: true
};

var propEnhancers = exports.propEnhancers = {
  boxSizing: function boxSizing(value) {
    return (0, _getCss2.default)(_boxSizing, value);
  },
  clear: function clear(value) {
    return (0, _getCss2.default)(_clear, value);
  },
  clearfix: function clearfix() {
    return {
      className: '📦clearfix',
      styles: '\n.\uD83D\uDCE6clearfix:before, .\uD83D\uDCE6clearfix:after {\n  display: table;\n  clear: both;\n  content: "";\n}'
    };
  },
  display: function display(value) {
    return (0, _getCss2.default)(_display, value);
  },
  float: function float(value) {
    return (0, _getCss2.default)(_float, value);
  },
  zIndex: function zIndex(value) {
    return (0, _getCss2.default)(_zIndex, value);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/enhancers/layout.js
// module id = 338
// module chunks = 0